/* Shared pouch cart: one first-box offer, regular extra pouches, actual Shopify totals. */
(function () {
  'use strict';
  var cfgNode = document.getElementById('MisuCartConfig');
  if (!cfgNode) return;
  var cfg = JSON.parse(cfgNode.textContent);
  var PLANS = cfg.plans;
  var GIFTS = cfg.gifts;
  var GIFT_VALUE = GIFTS.reduce(function (s, g) { return s + g.value; }, 0);
  var model = window.createMisuCartModel(cfg);
  var pageMount = document.querySelector('[data-cv-page]');
  var root = document.documentElement;
  root.classList.add('cv', 'cv-f');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  var N = function (v) { v = Number(v); return isFinite(v) ? v : 0; };
  var money = function (cents) { var n = N(cents) / 100; return '$' + (Number.isInteger(n) ? n : n.toFixed(2)); };
  var whole = function (cents) { return '$' + Math.round(N(cents) / 100); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  var state = { cart: cfg.cart || { items: [], item_count: 0, total_price: 0 }, open: false, busy: false };
  var measure = function (name, extra) {
    try {
      var box = model.read(state.cart);
      var params = Object.assign({
        purchase_type: box.mode === 'sub' ? 'subscription' : box.mode === 'once' ? 'one_time' : 'empty',
        offer_id: box.mode === 'sub' ? (box.free === 2 ? 'subscription_bundle5' : box.free ? 'subscription_bundle' : 'subscription_single') : box.mode === 'once' ? 'one_time' : 'empty',
        pouch_quantity: box.total,
        cart_value: N(state.cart.total_price) / 100,
        renewal_value: box.mode === 'sub' ? N(box.renewal) / 100 : 0
      }, extra || {});
      if (name === 'misu_checkout_clicked' && window.MisuCheckoutHandoff) window.MisuCheckoutHandoff.record(params, state.cart.currency || 'USD');
      if (window.MisuAnalytics) window.MisuAnalytics.track(name, params);
    } catch (_) {}
  };
  var measureCta = function (where, key) {
    try {
      var p = PLANS[key] || {};
      if (window.MisuAnalytics) window.MisuAnalytics.track('misu_cta_clicked', {
        cta_location: where,
        offer_id: key === 'once' ? 'one_time' : key === '150' ? 'subscription_bundle5' : key === '90' ? 'subscription_bundle' : 'subscription_single',
        purchase_type: key === 'once' ? 'one_time' : 'subscription',
        variant_id: String(p.id || ''), selling_plan_id: String(p.plan || '')
      });
    } catch (_) {}
  };
  var flushAnalytics = function () { try { if (window.MisuAnalytics) window.MisuAnalytics.flush(true); } catch (_) {} };

  /* ── cart api ── */
  var HEADERS = { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json' };
  // The landing page the shopper is buying from, saved on the order (snippets/misu-landing-memory.liquid).
  var landing = function () { try { return window.MisuLanding ? window.MisuLanding.attributes() : {}; } catch (_) { return {}; } };
  var api = function (path, body, opts) {
    if (body && /cart\/add\.js$/.test(path)) body = Object.assign({ attributes: landing() }, body);
    path = (cfg.root_url || '/') + path.replace(/^\//, '');
    var init = { method: body ? 'POST' : 'GET', headers: HEADERS, body: body ? JSON.stringify(body) : undefined };
    var silent = Boolean(opts && opts.silent);
    var req = silent && typeof Request === 'function'
      ? (window.__misuNativeFetch || fetch)(new Request(path, init))
      : fetch(path, init);
    return req
      .then(function (r) { return r.text().then(function (bodyText) {
        var data;
        try { data = JSON.parse(bodyText); } catch (_) { data = null; }
        if (!r.ok || !data || data.status >= 400) {
          var message = r.status === 422 && data ? data.description || data.message : '';
          var error = new Error(message || 'The store could not confirm this update. Please retry, or contact support@dailymisu.com.');
          error.status = r.status;
          console.warn('Misu cart request failed', { path: path.split('?')[0], status: r.status });
          throw error;
        }
        return data;
      }); });
  };
  var synchronize = window.createMisuCartSync(api, model);
  var withLock = function (action) {
    return navigator.locks ? navigator.locks.request('misu-cart', action) : action();
  };
  // Carts filled earlier, in another tab or by a recovery email name the current landing page too.
  var tagged = '';
  var tagLanding = function (cart) {
    var page = landing().landing_page;
    if (!page || page === tagged || !cart || !cart.item_count || (cart.attributes || {}).landing_page === page) return;
    tagged = page;
    withLock(function () { return api('/cart/update.js', { attributes: { landing_page: page } }, { silent: true }); }).catch(function () { tagged = ''; });
  };
  var announce = function () { if (channel) channel.postMessage('updated'); };
  var revision = 0;
  var refresh = function () {
    var requestedAt = ++revision;
    return api('/cart.js', null, { silent: true }).then(function (c) { if (requestedAt === revision) { state.cart = c; render(); } tagLanding(c); return c; });
  };
  var reconcile = async function () {
    var cart = await api('/cart.js', null, { silent: true });
    var box = model.read(cart);
    if (box.mode) cart = await synchronize(model.linesFor(box.mode, box.total), box.mode === 'sub' ? 'sub' : 'all', { silent: true });
    else if (box.gifts.length) cart = await synchronize([], 'sub', { silent: true });
    state.cart = cart;
    state.unconfirmed = false;
    tagLanding(cart);
  };
  var busy = function (action) {
    if (state.busy) return Promise.resolve(false);
    revision += 1;
    state.busy = true; state.error = ''; render();
    return Promise.resolve().then(function () { return withLock(action); }).then(function () {
      var giftProblem = model.giftError(state.cart);
      if (giftProblem) throw new Error(giftProblem);
      state.unconfirmed = false; announce(); window.dispatchEvent(new CustomEvent('misu:cart-snapshot', { detail: { cart: state.cart } })); return true;
    }).catch(function (e) {
      state.unconfirmed = !!e.unconfirmed;
      measure('misu_cart_error', { error_code: e.unconfirmed ? 'unconfirmed_update' : e.status === 422 ? 'shopify_rejected' : 'cart_update_failed' });
      state.error = 'Couldn’t update your box. ' + (e.message || 'Please try again.');
      return refresh().catch(function () { state.unconfirmed = true; }).then(function () { return false; });
    }).then(function (ok) {
      state.busy = false; state.pending = null; render(); return ok;
    });
  };
  var addKit = function (key, qty) {
    return busy(async function () {
      if (!PLANS[key]) throw new Error('Please choose an available pouch option.');
      var mode = key === 'once' ? 'once' : 'sub';
      var count = qty == null ? (key === '150' ? 5 : key === '90' ? 3 : 1) : model.quantity(qty);
      state.cart = await synchronize(model.linesFor(mode, count), 'all');
      measure('misu_cart_confirmed', { action: 'offer_added' });
      window.dispatchEvent(new CustomEvent('misu:cart-added'));
    });
  };
  var quantityPromise = null;
  var setQuantity = function (value) {
    var box = model.read(state.cart);
    if (!box.mode || state.busy && !quantityPromise) return Promise.resolve(false);
    try { state.pending = { mode: box.mode, total: model.normalize(box.mode, value) }; }
    catch (e) { state.error = e.message; render(); return Promise.resolve(false); }
    if (quantityPromise) { render(); return quantityPromise; }
    quantityPromise = busy(async function () {
      while (state.pending) {
        var target = state.pending;
        state.cart = await synchronize(model.linesFor(target.mode, target.total), target.mode);
        if (state.pending === target) state.pending = null;
        render();
      }
    }).then(function (ok) { quantityPromise = null; if (ok) measure('misu_cart_updated', { action: 'quantity_changed' }); return ok; });
    return quantityPromise;
  };
  var addForm = function (form) {
    var fd = new FormData(form);
    var line = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
    if (fd.get('selling_plan')) line.selling_plan = Number(fd.get('selling_plan'));
    var role = model.role(line);
    if (role === 'gift') return busy(async function () { throw new Error('This gift is included with a Misu starter box. Please choose your box first.'); });
    if (role) return addKit(role === 'once' ? 'once' : role === 'bundle5' ? '150' : role === 'bundle' ? '90' : '30', line.quantity * (role === 'bundle5' ? 5 : role === 'bundle' ? 3 : 1));
    var props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = v; });
    if (Object.keys(props).length) line.properties = props;
    return busy(async function () {
      if (!line.id) throw new Error('Please choose an available product.');
      line.quantity = model.quantity(line.quantity);
      await api('/cart/add.js', { items: [line] });
      await refresh();
      measure('misu_cart_confirmed', { action: 'product_added', variant_id: String(line.id), item_quantity: line.quantity });
      window.dispatchEvent(new CustomEvent('misu:cart-added'));
    });
  };
  var changeLine = function (key, qty) {
    var old = (state.cart.items || []).find(function (i) { return i.key === key; });
    return busy(async function () {
      qty = model.quantity(qty);
      var cart = await api('/cart.js');
      var item = cart.items.find(function (i) { return old && model.identity(i) === model.identity(old); });
      if (!item) { state.cart = cart; return; }
      if (model.role(item) === 'once') state.cart = await synchronize(model.linesFor('once', qty), 'once');
      else state.cart = await api('/cart/change.js', { id: item.key, quantity: qty });
      measure('misu_cart_updated', { action: qty === 0 ? 'line_removed' : 'quantity_changed' });
    });
  };

  /* ── markup ── */
  var qtyCtl = '<div class="cv-qty" aria-label="Quantity"><button type="button" data-cv-qty="-1" aria-label="Fewer">−</button><input data-cv-qtyn type="number" value="1" min="0" max="999" step="1" inputmode="numeric" aria-label="Number of pouches"><button type="button" data-cv-qty="1" aria-label="More">+</button></div>';
  var trash = '<button type="button" class="cv-trash" data-cv-remove aria-label="Remove from cart"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 10v7M14 10v7"/></svg></button>';
  var giftsList = GIFTS.map(function (g) {
    return '<li><img src="' + esc(g.img) + '" alt="" loading="lazy"><div><b>' + esc(g.name) + '</b></div><s>' + money(g.value) + '</s><em>Free</em></li>';
  }).join('');

  var drawer = document.createElement('div');
  drawer.className = 'cv-drawer';
  drawer.hidden = true;
  drawer.innerHTML =
    '<button type="button" class="cv-drawer__veil" data-cv-close aria-label="Close cart"></button>' +
    '<div class="cv-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="cvTitle" tabindex="-1">' +
      '<header class="cv-drawer__head"><div><h2 id="cvTitle">Your box</h2></div><div class="cv-drawer__tools"><span class="cv-count" data-cv-count>0 items</span><button type="button" class="cv-drawer__x" data-cv-close aria-label="Close cart">×</button></div></header>' +
      '<div class="cv-drawer__body">' +
        '<p class="cv-error" data-cv-error role="alert" hidden></p><button type="button" class="cv-retry" data-cv-retry hidden>Retry cart update</button>' +
        '<div class="cv-empty" data-cv-empty><h3>Your cart is empty.</h3><p>Nothing in here yet.</p><a href="' + esc(cfg.product_url) + '">Shop Misu</a></div>' +
        '<div class="cv-cart" data-cv-cart hidden>' +
          '<div data-cv-kit>' +
            '<div class="cv-fitem"><img class="cv-fitem__img" src="' + esc(cfg.pouch) + '" alt="Misu Gut Health Blend pouch"><div class="cv-fitem__txt"><b>Misu Original</b><span data-cv-contents></span><span class="cv-tag" data-cv-tag><i aria-hidden="true">✓</i>Subscription savings applied</span><p class="cv-fitem__price"><b data-cv-linetoday></b><s data-cv-linewas></s></p><div class="cv-fitem__ctl">' + qtyCtl + trash + '</div></div></div>' +
            '<section class="cv-incl" data-cv-gifts><h3>Included free with your first box</h3><ul>' + giftsList + '</ul></section>' +
            '<div class="cv-nudge" data-cv-nudge hidden><div><b>Subscribe instead?</b><span>' + whole(GIFT_VALUE) + ' of extras free, and ' + whole(PLANS.once.today - PLANS['30'].today) + ' less for the box.</span></div><button type="button" data-cv-add="30">Switch</button></div>' +
          '</div>' +
          '<ul class="cv-kit" data-cv-otherrows hidden></ul>' +
          '<section class="cv-addons" data-cv-mod><h3 data-cv-modtitle>Add to this box</h3><div data-cv-modbody></div></section>' +
        '</div>' +
      '</div>' +
      '<footer class="cv-drawer__foot">' +
        '<div class="cv-foot__save" data-cv-saverow hidden><span>Savings</span><span>−<span data-cv-savings></span></span></div>' +
        '<div class="cv-foot__sub"><span>Subtotal</span><b data-cv-total></b></div>' +
        '<a class="cv-checkout cv-checkout--wide" href="' + esc(cfg.checkout_url) + '" data-cv-checkout><span>Check out</span></a>' +
        '<p class="cv-guarantee"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 20 6v6c0 5-3.1 8.4-8 10-4.9-1.6-8-5-8-10V6l8-3Z"/><path d="m8.5 12 2.2 2.2 4.8-5"/></svg>30-Day Money-Back Guarantee</p>' +
      '</footer>' +
    '</div>';
  if (pageMount) {
    drawer.classList.add('cv-page'); drawer.hidden = false;
    drawer.querySelector('.cv-drawer__panel').setAttribute('role', 'region');
    drawer.querySelector('.cv-drawer__panel').removeAttribute('aria-modal');
    pageMount.replaceChildren(drawer);
  } else document.body.appendChild(drawer);
  document.querySelectorAll('[data-v3-offer], .product-form').forEach(function (box) {
    var error = document.createElement('p'); error.className = 'cv-error'; error.setAttribute('data-cv-error', ''); error.setAttribute('role', 'alert'); error.hidden = true; box.appendChild(error);
  });

  var all = function (sel, scope) { return [].slice.call((scope || document).querySelectorAll(sel)); };
  var text = function (name, value) { all('[data-cv-' + name + ']').forEach(function (n) { n.textContent = value; }); };
  var show = function (name, on) { all('[data-cv-' + name + ']').forEach(function (n) { n.hidden = !on; }); };

  /* ── render from the cart ── */
  var render = function () {
    var cart = state.cart, box = model.read(cart), sub = box.mode === 'sub';
    var q = box.total, shownQ = state.pending ? state.pending.total : q;
    var total = N(cart.total_price), others = box.others;
    var original = (cart.items || []).reduce(function (n, i) { return n + N(i.original_line_price == null ? i.final_line_price : i.original_line_price); }, 0);
    var managedOriginal = box.lines.reduce(function (n, i) { return n + N(i.original_line_price == null ? i.final_line_price : i.original_line_price); }, 0);
    var compareSavings = sub ? Math.max(0, box.compare - managedOriginal) : 0;
    var discounts = Math.max(0, original - total);
    var savings = compareSavings + discounts;
    var count = q + others.reduce(function (n, i) { return n + N(i.quantity); }, 0);
    drawer.classList.toggle('is-busy', state.busy);
    drawer.setAttribute('aria-busy', String(state.busy));
    text('count', count + (others.length ? ' items' : count === 1 ? ' pouch' : ' pouches'));
    all('[data-cv-error]').forEach(function (n) { n.textContent = state.error || ''; n.hidden = !state.error; });
    show('retry', !!state.error);
    all('[data-cart-count]').forEach(function (n) { n.textContent = count; n.hidden = !count; });
    show('empty', !count); show('cart', !!count); show('kit', !!box.mode);
    show('tag', !!box.free); show('gifts', sub); show('nudge', false);
    all('[data-cv-qtyn]').forEach(function (n) { if (document.activeElement !== n) n.value = shownQ; });
    text('linetoday', money(box.today)); text('linewas', compareSavings ? money(box.compare) : '');
    text('total', money(total)); text('savings', money(savings)); show('saverow', savings > 0);
    all('[data-cv-tag]').forEach(function (n) {
      n.innerHTML = box.free ? '<i aria-hidden="true">✓</i>' + box.free + ' free pouch' + (box.free === 1 ? '' : 'es') + ' in your first box' : '<i aria-hidden="true">✓</i>Subscription savings applied';
      n.classList.toggle('cv-tag--gold', !!box.free);
    });
    drawer.querySelector('.cv-fitem__txt > b').textContent = 'Misu Gut Health Blend with 5 Real Foods';
    var media = cfg.media && cfg.media[sub ? box.tier.key : 'once'];
    var itemImage = drawer.querySelector('.cv-fitem__img');
    itemImage.src = media && media.thumbnail || cfg.pouch;
    itemImage.alt = media && media.alt || 'Misu Gut Health Blend refill pouch';
    text('contents', sub ? (q > box.tier.pouches ? box.tier.pouches + '-pouch kit + ' + (q - box.tier.pouches) + ' extra pouch' + (q - box.tier.pouches === 1 ? '' : 'es') : q + ' pouch' + (q === 1 ? '' : 'es') + ' + scoop + frother') : q + ' refill pouch' + (q === 1 ? '' : 'es') + ' · one-time purchase');
    var pouchImg = '<img src="' + esc(cfg.pouch) + '" alt="">';
    var mod = drawer.querySelector('[data-cv-mod]'), modBody = drawer.querySelector('[data-cv-modbody]');
    if (sub && q === 1) {
      modBody.innerHTML = '<div class="cv-up"><span class="cv-up__vis">' + pouchImg + pouchImg + pouchImg + '<em>+1 free</em></span>' +
        '<div class="cv-up__t"><b>Add 1 more, get 1 free</b><span>3 pouches · ' + money(PLANS['90'].today) + ' today</span><span>First-box gift · an extra ' + money(PLANS.once.today) + ' value</span></div>' +
        '<button type="button" class="cv-up__go" data-cv-upgrade>Upgrade box</button></div>';
      mod.hidden = false;
    } else if (box.mode === 'once') {
      var switchCount = model.normalize('sub', q);
      var switchTier = model.tierFor(switchCount);
      var switchToday = N(PLANS[switchTier.key].today) + (switchCount - switchTier.pouches) * N(cfg.addon.today);
      var switchRenew = N(PLANS[switchTier.key].renew) + (switchCount - switchTier.pouches) * N(cfg.addon.renew);
      var switchRenewCount = switchCount - switchTier.free;
      modBody.innerHTML = '<div class="cv-sw"><div class="cv-sw__top"><div><b>Subscribe for ' + money(switchToday) + '</b><span>' + switchCount + (switchCount === 1 ? ' pouch' : ' pouches') + ' + first-box gifts</span><span>Then ' + switchRenewCount + ' pouch' + (switchRenewCount === 1 ? '' : 'es') + ' for ' + money(switchRenew) + ' every 30 days. Cancel anytime.</span></div><button type="button" class="cv-sw__go" data-cv-switch>Switch</button></div></div>';
      mod.hidden = false;
    } else { modBody.innerHTML = ''; mod.hidden = true; }
    var otherRows = drawer.querySelector('[data-cv-otherrows]');
    otherRows.hidden = !others.length;
    otherRows.innerHTML = others.map(function (i) {
      return '<li><span>' + esc(i.product_title) + '<small>' + esc(i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.name : 'One-time purchase') + '</small><label>Qty <input type="number" min="0" max="999" step="1" inputmode="numeric" value="' + N(i.quantity) + '" data-cv-otherqty="' + esc(i.key) + '" aria-label="Quantity of ' + esc(i.product_title) + '"></label></span><b>' + money(i.final_line_price) + '</b><button type="button" class="cv-trash" data-cv-removekey="' + esc(i.key) + '" aria-label="Remove ' + esc(i.product_title) + '">×</button></li>';
    }).join('');
    var disabled = !count || state.busy || state.unconfirmed || !!model.giftError(cart);
    var checkout = drawer.querySelector('[data-cv-checkout]');
    checkout.classList.toggle('is-disabled', !!disabled); checkout.setAttribute('aria-disabled', String(!!disabled));
    all('[data-cv-baradd]').forEach(function (n) { n.disabled = state.busy; });
    drawer.querySelectorAll('[data-cv-upgrade],[data-cv-switch],[data-cv-otherqty],[data-cv-removekey],[data-cv-retry]').forEach(function (n) { n.disabled = state.busy; });
  };

  /* ── open / close ── */
  var panel = drawer.querySelector('.cv-drawer__panel');
  var lastFocus = null;
  var bump = function (sel) { all(sel).forEach(function (n) { n.classList.remove('is-bump'); void n.offsetWidth; n.classList.add('is-bump'); }); };
  var open = function () {
    if (pageMount) { panel.focus(); return; }
    if (state.open) return;
    state.open = true;
    measure('misu_cart_opened');
    lastFocus = document.activeElement;
    drawer.hidden = false;
    var go = function () { drawer.classList.add('is-open'); root.classList.add('cv-open'); panel.focus(); };
    reduce ? go() : requestAnimationFrame(function () { requestAnimationFrame(go); });
  };
  var close = function () {
    if (!state.open) return;
    state.open = false;
    drawer.classList.remove('is-open');
    root.classList.remove('cv-open');
    var done = function () { if (!state.open) drawer.hidden = true; };
    reduce ? done() : setTimeout(done, 360);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  var openWith = function (promise) { return (promise || busy(reconcile)).then(function (ok) {
    if (ok === false) {
      var error = all('[data-cv-error]').filter(function (n) { return n.getClientRects().length && !n.hidden; })[0];
      if (error) error.scrollIntoView({ block: 'center', behavior: reduce ? 'instant' : 'smooth' });
      return;
    }
    open(); bump('[data-cv-count]');
  }).catch(function () { state.error = 'Couldn’t load your cart. Please try again.'; render(); }); };

  /* ── clicks inside the drawer ── */
  drawer.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cv-close],[data-cv-upgrade],[data-cv-switch],[data-cv-qty],[data-cv-remove],[data-cv-removekey],[data-cv-checkout],[data-cv-retry]');
    if (!t) return;
    if (t.hasAttribute('data-cv-close')) { close(); return; }
    if (t.hasAttribute('data-cv-checkout')) {
      e.preventDefault();
      if (!state.cart.item_count || state.busy || state.unconfirmed) return;
      var prior = JSON.stringify(state.cart.items.map(function (i) { return [i.key, i.quantity, i.final_line_price]; }));
      busy(reconcile).then(function (ok) {
        if (!ok) return;
        var current = JSON.stringify(state.cart.items.map(function (i) { return [i.key, i.quantity, i.final_line_price]; }));
        if (prior !== current) { state.error = 'Your cart has changed. Review your updated box before checking out.'; render(); return; }
        measure('misu_checkout_clicked', { cta_location: 'cart' });
        flushAnalytics();
        if (window.MisuCheckoutHandoff) window.MisuCheckoutHandoff.navigate(cfg.checkout_url);
        else location.assign(cfg.checkout_url);
      }); return;
    }
    if (t.hasAttribute('data-cv-retry')) { busy(reconcile); return; }
    var box = model.read(state.cart);
    if (t.hasAttribute('data-cv-qty') && box.mode) {
      try { setQuantity(model.next(box.mode, state.pending ? state.pending.total : box.total, Number(t.getAttribute('data-cv-qty')))); }
      catch (err) { state.error = err.message; render(); }
      return;
    }
    if (t.hasAttribute('data-cv-remove') && box.mode) { setQuantity(0); return; }
    if (state.busy) return;
    if (t.hasAttribute('data-cv-upgrade')) { setQuantity(3); return; }
    if (t.hasAttribute('data-cv-switch')) { addKit('30', model.normalize('sub', box.total)); return; }
    if (t.hasAttribute('data-cv-removekey')) changeLine(t.getAttribute('data-cv-removekey'), 0);
  });
  drawer.addEventListener('change', function (e) {
    if (e.target.matches('[data-cv-qtyn]')) {
      var value = e.target.value;
      if (value.trim() === '') { e.target.value = model.read(state.cart).total; return; }
      setQuantity(value).then(function () { e.target.value = model.read(state.cart).total; });
    }
    if (e.target.matches('[data-cv-otherqty]')) changeLine(e.target.getAttribute('data-cv-otherqty'), e.target.value);
  });
  drawer.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('input[type="number"]')) e.target.blur(); });
  document.addEventListener('keydown', function (e) {
    if (!state.open) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var focusable = all('a[href]:not([aria-disabled="true"]),button:not(:disabled),input:not(:disabled),[tabindex="0"]', panel).filter(function (n) { return n.getClientRects().length > 0; });
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (!first) { e.preventDefault(); panel.focus(); return; }
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });

  var checkoutWith = function (promise) {
    return promise.then(function (ok) {
      if (ok) { measure('misu_checkout_clicked', { cta_location: 'product' }); flushAnalytics(); if (window.MisuCheckoutHandoff) window.MisuCheckoutHandoff.navigate(cfg.checkout_url); else window.location.assign(cfg.checkout_url); return; }
      var error = all('[data-cv-error]').filter(function (n) { return n.getClientRects().length && !n.hidden; })[0];
      if (error) error.scrollIntoView({ block: 'center', behavior: reduce ? 'instant' : 'smooth' });
    });
  };

  /* ── PDP purchases go directly to checkout; cart links open the drawer ── */
  var cartHref = function (a) { var h = a.getAttribute('href') || ''; return h === cfg.cart_url || /\/cart\/?(\?.*)?$/.test(h); };
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cart-open], [data-v3-once], .product-one-time, a[href], button');
    if (!a) return;
    if (e.target.closest('[data-v3-once], a.product-one-time')) {
      e.preventDefault(); e.stopImmediatePropagation();
      measureCta('one_time_offer', 'once');
      if (!state.busy) checkoutWith(addKit('once'));
      return;
    }
    if (a.hasAttribute('data-cart-open') || (a.tagName === 'A' && cartHref(a))) {
      e.preventDefault(); e.stopImmediatePropagation();
      openWith();
      return;
    }
    /* homepage buy box: the CTA adds the plan chosen in the box */
    var cta = e.target.closest('a,button');
    if (cta && cta.querySelector('[data-cta-price]')) {
      e.preventDefault(); e.stopImmediatePropagation();
      measureCta('home_offer', readBuyBox());
      checkoutWith(addKit(readBuyBox()));
    }
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !window.fetch) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (state.busy) return;
    var direct = form.getAttribute('id') === 'ProductForm' || form.hasAttribute('data-direct-checkout');
    var selected = form.querySelector('[name="cadence"]:checked');
    var selectedKey = selected ? (selected.value === 'bundle5' ? '150' : selected.value === 'bundle' ? '90' : '30') : 'once';
    measureCta(direct ? 'product_offer' : 'product_form', selectedKey);
    var buttons = all('button[type="submit"], input[type="submit"]').filter(function (button) { return button.form === form; });
    var disabled = buttons.map(function (button) { return button.disabled; });
    buttons.forEach(function (button) { button.disabled = true; });
    checkoutWith(addForm(form)).finally(function () {
      buttons.forEach(function (button, index) { button.disabled = disabled[index]; });
    });
  }, true);

  /* the homepage buy box (v3) — the plan chosen there */
  var subscribeOption = document.querySelector('[data-plan-role="sub"]');
  var cadenceButtons = all('.cad [role="radio"]');
  var planButtons = all('.plans > [role="radio"]');
  var readBuyBox = function () {
    var o1 = document.querySelector('[data-v3-plan][aria-checked="true"]');
    if (o1) return o1.getAttribute('data-v3-plan');
    if (!subscribeOption) return '30';
    if (subscribeOption.getAttribute('aria-checked') !== 'true') return 'once';
    return cadenceButtons.map(function (b) { return b.getAttribute('aria-checked') === 'true'; }).indexOf(true) === 1 ? '90' : '30';
  };

  /* ── the sticky bar (pages with the buy box) ── */
  var buyCta = document.querySelector('[data-cta-price]');
  buyCta = buyCta && buyCta.closest('a,button');
  if (buyCta) {
    /* the sticky bar (locked 2026-09-04): thumbnail, price, one action */
    var bar = document.createElement('div');
    bar.className = 'cv-bar cv-bar--float';
    bar.innerHTML = '<img class="cv-bar__thumb" src="' + esc(cfg.pouch) + '" alt="">' +
      '<div class="cv-bar__txt"><span class="cv-bar__p"><b data-cv-bartoday></b><s data-cv-barwas></s></span><small data-cv-barevery></small></div>' +
      '<button type="button" class="cv-bar__cta" data-cv-baradd><span>Add to cart</span><i>→</i></button>';
    document.body.appendChild(bar);
    var paintBar = function () {
      var key = readBuyBox(); var p = PLANS[key] || PLANS['30']; var sub = !!p.plan;
      var media = cfg.media && cfg.media[key];
      var thumb = bar.querySelector('.cv-bar__thumb');
      thumb.src = media && media.thumbnail || cfg.pouch;
      thumb.alt = media && media.alt || 'Misu Gut Health Blend refill pouch';
      text('bartoday', money(p.today));
      all('[data-cv-barwas]').forEach(function (n) { n.textContent = p.compare ? money(p.compare) : ''; n.hidden = !p.compare; });
      text('barevery', sub ? 'Then ' + money(p.renew) + ' every ' + p.every + ' · free shipping' : 'One box · $4.95 shipping');
      text('unlocktitle', sub ? '3 gifts unlocked' : 'Subscribe to unlock 3 gifts');
      all('[data-cv-chip]').forEach(function (n) { n.classList.toggle('is-on', sub); });
    };
      cadenceButtons.concat(planButtons).concat(all('[data-v3-plan]')).forEach(function (b) { b.addEventListener('click', function () { setTimeout(paintBar, 0); }); });
    bar.querySelector('[data-cv-baradd]').addEventListener('click', function () { measureCta('sticky_offer', readBuyBox()); checkoutWith(addKit(readBuyBox())); });
    paintBar();
    var heroes = all('.hero');
    var footer = document.querySelector('footer');
    var vis = { ctaSeen: false, atFooter: false };
    var paint = function () {
      var hero = heroes.filter(function (h) { return h.getBoundingClientRect().height > 0; })[0];
      var pastHero = !hero || hero.getBoundingClientRect().bottom <= 0;
      bar.classList.toggle('is-visible', pastHero && !vis.ctaSeen && !vis.atFooter);
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === buyCta) vis.ctaSeen = en.isIntersecting;
          if (en.target === footer) vis.atFooter = en.isIntersecting;
        });
        paint();
      });
      heroes.concat([buyCta, footer]).filter(Boolean).forEach(function (n) { io.observe(n); });
    }
    addEventListener('resize', paint, { passive: true });
    var mobar = document.getElementById('mobar');
    if (mobar) mobar.hidden = true;
  }

  var channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('misu-cart') : null;
  if (channel) channel.onmessage = function () { if (!state.busy) refresh().catch(function () {}); };
  addEventListener('pageshow', function (e) { if (e.persisted && !state.busy) busy(reconcile); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden && !state.busy) refresh().catch(function () {}); });
  render();
  tagLanding(state.cart);
  if (pageMount) busy(reconcile);
  window.MisuCart = { restore: async function(work) { var ok=await busy(async function(){state.cart=await work();}); if(!ok)throw new Error(state.error || 'Your saved cart could not be restored.'); return state.cart; }, open: open, close: close, add: addKit, refresh: refresh, setQuantity: setQuantity, model: model, render: render, state: state };
})();
